export default __webpack_public_path__ + "static/media/025-powerplant.1ca4db4e.svg";